import { useEffect, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import snakeCase from 'lodash/snakeCase';
import toUpper from 'lodash/toUpper';
import get from 'lodash/get';
import { uncapitalize } from 'lib/utils';
import { useDispatch, useSelector } from 'hooks';
import * as Actions from '@/redux/actions';
import * as Constants from '@/redux/constants';

function DialogDelete({ open, onClose, model, id, payload = {} }) {
  const { itemInfo } = useSelector((state) => ({
    itemInfo: get(state, `${uncapitalize(model)}Info`),
  }), shallowEqual);
  const dispatch = useDispatch();
  const modelName = useMemo(() => model.replace(/([A-Z])/g, ' $1').trim(), [model]);
  const onConfirm = useCallback(() => {
    dispatch(Actions[`delete${model}`]({ payload: { ...payload, id } }));
  }, [dispatch, model, id]);

  useEffect(() => {
    const con = toUpper(snakeCase(model));
    switch (itemInfo.type) {
      case Constants[`DELETE_${con}`].SUCCESS:
        onClose();
        break;
    }
  }, [itemInfo, model, onClose]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete {modelName}</DialogTitle>
      <DialogContent>
        Are you sure you want to delete this {uncapitalize(modelName.toLowerCase())}?
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="primary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}

DialogDelete.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  model: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  payload: PropTypes.object,
};

export default DialogDelete;
